import React from "react";
import EpisodesPage from "../catalogue/EpisodesPage";
import {
  deleteEpisode,
  getEpisode,
  getEpisodeList,
  getSeasonList,
  getTvShow,
  updateEpisode,
  updateEpisodeMedia,
} from "../../../services/shows";
import { createEpisodeGeneralContent } from "../../../store/actions/uploadMediaAction";

const noExtraTags = () => [];

const EpisodeList = () => (
  <EpisodesPage
    idParam="show_id"
    loadSeries={getTvShow}
    loadSeasons={getSeasonList}
    loadEpisodes={getEpisodeList}
    loadEpisode={getEpisode}
    create={createEpisodeGeneralContent}
    update={updateEpisode}
    remove={deleteEpisode}
    linkMedia={updateEpisodeMedia}
    tagType="tvshow"
    extraJwTags={noExtraTags}
    pricing
    seriesPath={(id) => `/dashboard/update-show/${id}`}
    infoPath={(id) => `/dashboard/episode-info/${id}`}
    texts={{ noSeasons: "Please Add Seasons to the Show First!", editSeries: "Edit Show" }}
  />
);

export default EpisodeList;
